import tracking from 'dibs-tracking';

const heroList = 'main hero carousel';

function buildProductTrackingData({ item, index, list }) {
    const product = {
        dimension83: item.contemporaryTrackingString,
        url: item.link,
        name: item.title,
        position: index + 1,
        list,
    };

    return product;
}

function trackHeroImpression({ items, startIndex }) {
    tracking.trackEcommerce({
        type: 'productImpression',
        products: items.map((item, index) =>
            buildProductTrackingData({
                item,
                index: startIndex + index,
                list: heroList,
            })
        ),
    });
}

function trackHeroItemClick({ item, index }) {
    tracking.trackEcommerce({
        type: 'productClick',
        actionField: { list: heroList },
        products: [buildProductTrackingData({ item, index })],
    });
}

export { trackHeroImpression, trackHeroItemClick };
